import { useMemo } from 'react'

import { InvoiceEventFileType } from '@features/invoices/enums/invoiceEventFileType'
import { InvoiceEventType } from '@features/invoices/enums/invoiceEventType'
import type { InvoiceEvent } from '@features/invoices/types/invoices/invoiceEvent'

import { useInvoice } from '../../../contexts/invoiceContext'

const allValidStatusEvents = Object.values(InvoiceEventType)
const fileTypesToIgnore: InvoiceEventFileType[] = ['en16931', 'zugferd_pdf']

const isVisibleTimelineEvent = ({ eventType, eventData }: InvoiceEvent): boolean => {
  // FileZugferdGenerated also fires for "send as e-invoice" (en16931) and plain PDF generation
  // (zugferd_pdf); only the direct XRechnung download belongs in the timeline.
  if (eventType === InvoiceEventType.FileZugferdGenerated) {
    return !fileTypesToIgnore.includes(eventData?.fileType as InvoiceEventFileType)
  }

  return allValidStatusEvents.includes(eventType)
}

export const useSupportedInvoiceStatusEvents = () => {
  const { invoice, isFetching } = useInvoice()
  const documentType = invoice?.documentType
  const invoiceBillingStage = invoice?.billingStage

  const supportedStatusEvents = useMemo(() => {
    const statusEvents = invoice?.status?.events ?? []

    return statusEvents.filter(isVisibleTimelineEvent)
  }, [invoice?.status?.events])

  return { documentType, invoiceBillingStage, isLoading: isFetching, supportedStatusEvents }
}
